import React, {useState} from "react";
import TaskMainContainer from "./TaskMainContainer";
import '../styles/logicWheel2.css';

import dragImg11 from "../images/arrangeByColumns/LogicWedge3_1_1.png";
import dragImg12 from "../images/arrangeByColumns/LogicWedge3_1_2.png";
import dragImg13 from "../images/arrangeByColumns/LogicWedge3_1_3.png";

import dragImg21 from "../images/arrangeByColumns/LogicWedge3_2_1.png";
import dragImg22 from "../images/arrangeByColumns/LogicWedge3_2_2.png";
import dragImg23 from "../images/arrangeByColumns/LogicWedge3_2_3.png";

import dragImg31 from "../images/arrangeByColumns/LogicWedge3_3_1.png";
import dragImg32 from "../images/arrangeByColumns/LogicWedge3_3_2.png";
import dragImg33 from "../images/arrangeByColumns/LogicWedge3_3_3.png";

import ArrangeByColumns from "./ArrangeByColumns";
import bgNature from '../images/bgNature.png';


const LogicWedge3 = (props) => {
  const [allComplete, setAllComplete] = useState(false);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const chooseTasks = [
    {
      title: 'All titles are false. Move the pictures',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Reduce the effort"},
        {id: 2, successAnswerId: 1, title: "Doesn’t reduce the effort", titleFontSize: '2.3em'},
        {id: 3, successAnswerId: 2, title: "Has no wheels"},
      ],
      dragItems: [
        {id: 1, image: dragImg11},
        {id: 2, image: dragImg12},
        {id: 3, image: dragImg13},
      ]
    },
    {
      title: 'All titles are false. Move the pictures',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Simple machine"},
        {id: 2, successAnswerId: 1, title: "Ramp"},
        {id: 3, successAnswerId: 2, title: "Not a simple machine"},
      ],
      dragItems: [
        {id: 1, image: dragImg23},
        {id: 2, image: dragImg21},
        {id: 3, image: dragImg22},
      ]
    },
    {
      title: 'All titles are false. Move the pictures',
      columnsItems: [
        {id: 1, successAnswerId: 3, title: "Has no wheels"},
        {id: 2, successAnswerId: 1, title: "Not a pulley"},
        {id: 3, successAnswerId: 2, title: "Has an axle"},
      ],
      dragItems: [
        {id: 1, image: dragImg31},
        {id: 2, image: dragImg32},
        {id: 3, image: dragImg33},
      ]
    },
  ]

  return (
    <TaskMainContainer
      lessonCode={props.lessonCode}
      tasksCount={chooseTasks.length}
      completeCount={completedTaskCount}
      setCompletedTaskCount={setCompletedTaskCount}
      taskComplete={allComplete}
    >
      <div className={'logic-wheel-2'}>
        {
          chooseTasks.map((item, i) => (
            <React.Fragment key={`step${i}`}>
              {
                ((completedTaskCount === (i)) || ((i+1) === chooseTasks.length && completedTaskCount >= chooseTasks.length)) ? (
                  <ArrangeByColumns
                    lang={'en'}
                    bgImg={bgNature}
                    title={item.title}
                    columns={item.columnsItems}
                    dragItems={item.dragItems}
                    taskComplete={() => {
                      setCompletedTaskCount(prevState => prevState + 1);
                      if ((i + 1) === chooseTasks.length) {
                        setAllComplete(true);
                      }
                    }}
                  />
                ) : null
              }
            </React.Fragment>
          ))
        }
      </div>
    </TaskMainContainer>
  )
}
export default LogicWedge3;
